package com.essntl.features.itinerary.ui.edit_itinerary_service

import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import com.essntl.core.utils.viewmodel.State
import com.essntl.core.waypoint.domain.models.WaypointLogs
import com.essntl.features.address.domain.model.GooglePlaceModel
import com.essntl.features.category.domain.model.CategoryModel
import com.essntl.features.client.domain.model.ClientModel
import com.essntl.features.file.ui.FileState
import com.essntl.features.itinerary.domain.model.ItineraryModel
import com.essntl.features.itinerary.domain.model.ItineraryServiceModel
import com.essntl.features.message.domain.model.MessageModel
import com.essntl.features.message.domain.model.WhapiMessageModel
import com.essntl.features.profile.domain.model.ProfileModel
import com.essntl.features.request.domain.model.RequestModel
import com.essntl.features.service.domain.model.supplierservice.SupplierServiceModel
import com.essntl.features.supplier.domain.model.SupplierModel
import com.essntl.features.task.domain.model.TaskModel

data class EditItineraryServiceState(
    // Itinerary
    val getItinerary: State<ItineraryModel> = State(),
    val getAllSuppliers: State<List<SupplierServiceModel>> = State(),
    val getSupplier: State<SupplierModel> = State(),
    // Attachments
    val fileState: FileState = FileState(),
    // Itinerary Service
    val getItineraryService: State<ItineraryServiceModel> = State(),
    val updateItineraryService: State<ItineraryServiceModel> = State(),
    val itineraryService: MutableState<ItineraryServiceModel> = mutableStateOf(ItineraryServiceModel.empty),

    // Task
    val getAllItineraryServiceTask: State<List<TaskModel>> = State(),
    val updateTaskLoading: Set<String> = emptySet(),
    val deleteTaskLoading: Set<String> = emptySet(),

    // Message
    val sendMessageList: State<Unit> = State(),
    val whapiMessagesList: State<List<WhapiMessageModel>> = State(),
    val waypointLogsList: State<List<WaypointLogs>> = State(),
    val getAllMessages: State<List<MessageModel>> = State(),
    val sendMessageLoading: Set<String> = emptySet(),
    val checkContact: State<Unit> = State(),
    val sendContact: State<Unit> = State(),

    // Category
    val getAllCategory: State<List<CategoryModel>> = State(),

    // Profile
    val getProfile: State<ProfileModel> = State(),
    val getCurrentProfile: State<ProfileModel> = State(),
    val getAllProfile: State<List<ProfileModel>> = State(),

    // Client
    val client: ClientModel = ClientModel.empty,

    // Request
    val request: RequestModel = RequestModel.empty,

    // Address
    val getAllPlaces: State<List<GooglePlaceModel>> = State(),
    val selectedPlace: GooglePlaceModel? = null,
    val setPlace: State<String> = State(),

    val isEditEnabled: Boolean = false,
)